import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { withThemeAndSize } from "../../withThemeAndSize/index.js";
import { cn as clsx } from "../../../helpers/react.js";
import '../../../assets/index14.css';const root = "_root_zv9oo_2";
const prefix = "_prefix_zv9oo_24";
const value = "_value_zv9oo_28";
const critical = "_critical_zv9oo_45";
const warning = "_warning_zv9oo_51";
const success = "_success_zv9oo_57";
const disabled = "_disabled_zv9oo_63";
const s = {
  root,
  prefix,
  value,
  "default": "_default_zv9oo_39",
  critical,
  warning,
  success,
  disabled
};
const TIME_BADGE_INTENT = {
  critical: "critical",
  warning: "warning",
  success: "success",
  default: "default"
};
const INTENT_TO_CLASS_MAP = {
  critical: s.critical,
  warning: s.warning,
  success: s.success,
  default: s.default
};
const TimeBadge = withThemeAndSize(
  forwardRef(
    ({ children, disabled: disabled2, intent = TIME_BADGE_INTENT.default, className, prefix: prefix2 = "D", value: value2 = 0, ...htmlProps }, ref) => {
      let derivedValue;
      if (typeof value2 === "string") {
        derivedValue = value2;
      } else if (Number.isFinite(value2)) {
        derivedValue = `${value2 > 0 ? "+" : ""}${value2}`;
      }
      if (!derivedValue) {
        return null;
      }
      return /* @__PURE__ */ jsxs(
        "span",
        {
          ...htmlProps,
          ref,
          className: clsx(s.root, { [s.disabled]: disabled2 }, INTENT_TO_CLASS_MAP[intent], className),
          children: [
            prefix2 && /* @__PURE__ */ jsx("span", { className: s.prefix, children: prefix2 }),
            derivedValue && /* @__PURE__ */ jsx("span", { className: s.value, children: derivedValue }),
            children
          ]
        }
      );
    }
  )
);
export {
  TIME_BADGE_INTENT,
  TimeBadge
};
